import {
  createAsyncThunk, createSlice, EntityState, PayloadAction,
} from '@reduxjs/toolkit';
import { fetchDefaultLayout, fetchLayouts } from 'api/layout.service';
import { normalize } from 'normalizr';
import { projectReadActions } from 'redux/project-read/project-read.slice';
import { LayoutResponse } from 'types/entity/layout-response';
import { LayoutSchema } from 'types/schema/layout-schema';
import { layoutSchema, layoutsAdapter } from './layout-read.adapter';

export const LAYOUT_READ_STORE_NAME = 'layoutRead';

export const loadLayouts = createAsyncThunk(
  `${LAYOUT_READ_STORE_NAME}/load`,
  async (projectId: string, thunkAPI) => {
    const response = await fetchLayouts(projectId);
    const normalized = normalize(response, [layoutSchema]);
    return normalized.entities as LayoutSchema;
  },
);

export const loadDefaultLayout = createAsyncThunk(
  `${LAYOUT_READ_STORE_NAME}/loadDeault`,
  async (projectId: string) => {
    const response = await fetchDefaultLayout(projectId);
    return response;
    // const normalized = normalize(response, layoutSchema)
    // return normalized.entity
  },
);

export type LayoutReadState = EntityState<LayoutResponse> & {
  selectedId: string
  loaded: boolean
  error?: any
}

export const initialLayoutReadState: LayoutReadState = layoutsAdapter.getInitialState({
  selectedId: '',
  loaded: false,
  error: null,
});

export const layoutReadSlice = createSlice({
  name: LAYOUT_READ_STORE_NAME,
  initialState: initialLayoutReadState,
  // awaitでないAction系
  reducers: {
    selectOne: (state, action: PayloadAction<string>) => {
      state.selectedId = action.payload;
    },
  },
  // awaitするAction系
  extraReducers: (builder) => {
    builder.addCase(loadLayouts.pending, (state) => {
      layoutsAdapter.removeAll(state);
      state.loaded = false;
    });
    builder.addCase(loadLayouts.fulfilled, (state, action) => {
      layoutsAdapter.addMany(state, action.payload.layouts || {});
      state.loaded = true;
    });
    builder.addCase(loadLayouts.rejected, (state, action) => {
      state.error = action.payload;
      state.loaded = true;
    });
    builder.addCase(loadDefaultLayout.pending, (state) => {
      state.loaded = false;
    });
    builder.addCase(loadDefaultLayout.fulfilled, (state, action) => {
      state.selectedId = action.payload.layout_id || '';
      state.loaded = true;
    });
    builder.addCase(loadDefaultLayout.rejected, (state, action) => {
      state.error = action.payload;
      state.loaded = true;
    });
    // プロジェクト切り替え時
    builder.addCase(projectReadActions.selectOne, (state) => {
      layoutsAdapter.removeAll(state);
      state.loaded = false;
    });
  },
});

// Action creators are generated for each case reducer function
export const layoutReadActions = {
  ...layoutReadSlice.actions,
  loadLayouts,
  loadDefaultLayout,
};

export default layoutReadSlice.reducer;
